import { useContrastText } from "native-base";
export const useContrastProps = (bg = "primary.500") => {
    return {
        bg,
        color: useContrastText(bg)
    }
}
export {useContrastText}